import { QuestionBase } from './question-base';

export class TextareaFancyQuestion extends QuestionBase<string> {
  controlType = 'textarea-fancy';
  type: string;

  constructor(options: {} = {}) {
    super(options);
    this.type = options['type'] || '';
  }
}
